import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';

function QRWithExpiry({ value, size = 280, expiresAt, totalSeconds = 30 }) {
  const [timeLeft, setTimeLeft] = useState('');
  const [secondsLeft, setSecondsLeft] = useState<number>(totalSeconds);
  useEffect(() => {
    if (!expiresAt) return;
    const run = () => {
      const sec = Math.max(0, Math.floor((Number(new Date(expiresAt as string)) - Date.now()) / 1000));
      setSecondsLeft(sec);
      setTimeLeft(sec > 0 ? `QR code Expires in: ${sec}s` : 'Expired');
    };
    run();
    const t = setInterval(run, 1000);
    return () => clearInterval(t);
  }, [expiresAt]);
  const barWidthPercent = totalSeconds > 0 ? Math.min(100, (secondsLeft / totalSeconds) * 100) : 0;
  const barColor =
    barWidthPercent > 50 ? 'success.main' : barWidthPercent > 25 ? 'warning.main' : 'error.main';
  return (
    <Box sx={{ textAlign: 'center' }}>
      {value && (
        <Box sx={{ width: '90%', '& svg': { width: '90%', height: 'auto', display: 'block', margin: '0 auto' } }}>
          <QRCodeSVG value={value} size={size} level="M" includeMargin />
        </Box>
      )}
      <Box sx={{ mt: 1.5, width: '100%' }}>
        <Box
          sx={{
            width: '100%',
            height: 10,
            borderRadius: 1,
            bgcolor: 'action.hover',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              width: `${barWidthPercent}%`,
              height: '100%',
              bgcolor: barColor,
              borderRadius: 1,
              transition: 'width 1s linear, background-color 0.3s ease',
            }}
          />
        </Box>
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1, fontSize: '1.2rem' }}>
        {timeLeft}
      </Typography>
    </Box>
  );
}

export default QRWithExpiry;
